/*

Prakash 29-10-2022 2701234204 added styling classes for buttons.
Raghu 27/10/2022 2701234204 Font size fixes
Rohini 31/10/2022 2701234204 Removed classname for card
Ashraf 12/15/2022 2701234204 fixed role access
Sohel 02/16/2023 2701234204 Changed Validation message
Sohel 02/22/2023 2701234204 removed status field
Rohini 03/14/2023 2701234204 fixed the button responsive.
Ravi 04/19/2023 2701234204 modified client code dropDownData data.
Prakash 26-05-2023 2701234204 added styling classes for buttons.
Ravi 06/26/2023 2701234204 fixed submit issue
uday 09/29/2023 2701234204 fixed alignments issues in desktop and largescreen and tab view
*/

import React, {useEffect, useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {
  TextField,
  FormControl,
  Button,
  FormHelperText,
  InputAdornment,
} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {Controller} from 'react-hook-form';
import endOfDay from 'date-fns/endOfDay';
import {ThemeContext} from '../../themes/ThemeProvider';
import {
  getDropDownData,
  postPatientContact,
  resetMessage,
} from '../../redux/reducers/AddPatient';
import PageLoader from '../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
import {DISPOSITION_CODE, PHASE} from '../../constants/Lookup';
import {useHistory} from 'react-router';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {getClientCodeDropDownData} from '../../redux/reducers/TriggerGroup';
import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
import FormFielsSet from './FormFielsSet';
import PatientCustomerInformation from './PatientCustomerInformation';
import POEInformation from './POEInformation';
import {Currency} from '../../util/Currency';
import NumberFormat from 'react-number-format';
import {getFormattedDate} from '../../util/dateHelper';
import moment from 'moment';
import GuiTextDateField from '../../components/FormComponents/GuiTextDateField';
export default function CreateAccount() {
  const history = useHistory();
  const [disabled, setdisabled] = useState(false);
  const {
    clientCodeData,
    isLoading,
    errorMsg,
    successMsg,
    addPatientStatus,
    dropDownData,
    accountNumber,
  } = useSelector(({addPatient}) => addPatient);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {roleData} = useSelector(({role}) => role);
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const roleAccess = roleData?.window?.['Add Account']?.['AA'];

  const dispatch = useDispatch();
  const initialValues = {
    clientCode: null,
    clientAccountNumber: '',
    status: null,
    phase: null,
    waitDate: null,
    dateOfService: null,
    admitDate: null,
    dischargeDate: null,
    initialBalance: 0.0,
    totalCharges: 0.0,

    patientFirstName: '',
    patientLastName: '',
    patientDateOfBirth: null,
    mrnNumber: '',
    ssnNumber: '',
    patientPhone: '',
    patientEmail: '',
    patientAddressLine1: '',
    patientAddressLine2: '',
    patientCity: '',
    patientState: null,
    patientZip: '',

    rpFirstName: '',
    rpLastName: '',
    rpSSN: '',
    rpPhone: '',

    POEName: '',
    POEAddressLine1: '',
    POEAddressLine2: '',
    POECity: '',
    POEState: null,
    POEZip: '',
    POEPhone: '',
  };
  const temp = new Date();
  temp.setDate(temp.getDate()-1);
  const validationSchema = Yup.object().shape({
    clientCode: Yup.mixed().required('Client Code is required').nullable(),
    status: Yup.mixed().required('Status is required').nullable(),
    phase: Yup.mixed().required('Phase is required').nullable(),
    waitDate: Yup.date()
      .min(new Date(temp), 'Wait Date cannot be Past Date')
      .nullable()
      .typeError('Invalid date format')
      .test('waitDate', 'Invalid date format', function(val) {
        if (new Date(val)) {
          return true;
        } else {
          return false;
        }
      }),
    dateOfService: Yup.date()
      .nullable()
      .typeError('Invalid date format')
      .test('dateOfService', 'Invalid date format', function(val) {
        if (new Date(val)) {
          return true;
        } else {
          return false;
        }
      }),
    admitDate: Yup.date()
      .nullable()
      .typeError('Invalid date format')
      .test('admitDate', 'Invalid date format', function(val) {
        if (new Date(val)) {
          return true;
        } else {
          return false;
        }
      }),
    dischargeDate: Yup.date()
      .nullable()
      .typeError('Invalid date format')
      .test('dischargeDate', 'Discharge Date cannot less than Admit Date', function(val, context) {
        const values = context?.parent;
        if (values?.admitDate > val) {
          return false;
        } else {
          return true;
        }
      })
      .test('dischargeDate', 'Invalid date format', function(val) {
        if (new Date(val)) {
          return true;
        } else {
          return false;
        }
      }),
    patientFirstName: Yup.string()
      .required('First Name is required')
      .max(25, 'First Name cannot exceed 25 characters'),

    patientLastName: Yup.string()
      .required('Last Name is required')
      .max(25, 'Last Name cannot exceed 25 characters'),
    patientDateOfBirth: Yup.date()
      .required('Birth Date is required')
      .max(endOfDay(new Date()), 'Birth Date cannot be Future Date')
      .nullable()
      .typeError('Invalid date format')
      .test('patientDateOfBirth', 'Invalid date format', function(val) {
        if (new Date(val)) {
          return true;
        } else {
          return false;
        }
      }),
    patientPhone: Yup.string()
      .nullable()
      .test('patientPhone', 'Invalid phone number', (value) => {
        value = value && value.replace(/[^\d]/g, '');
        if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
          return true;
        }
      })
      .required('Phone is required'),
    patientEmail: Yup.string().email('Invalid email format'),
    patientAddressLine1: Yup.string().required('Address Line 1 is required'),
    patientCity: Yup.string()
      .required('City is required')
      .max(20, 'City cannot exceed more than 20 characters'),

    patientState: Yup.mixed().required('State is required').nullable(),
    patientZip: Yup.string()
      .required('Zip is required')
      .min(5, 'Zip cannot exceed less than 5 characters')
      .max(9, 'Zip cannot exceed more than 9 characters'),

    rpFirstName: Yup.string().when('patientDateOfBirth', (patientDateOfBirth, schema) => {
      if (new Date().getFullYear() - new Date(patientDateOfBirth).getFullYear() <= 18) {
        return schema
          .required('RP First Name is required')
          .max(25, 'RP First Name cannot exceed 25 characters');
      }
      return schema;
    }),
    rpLastName: Yup.string().when('patientDateOfBirth', (patientDateOfBirth, schema) => {
      if (new Date().getFullYear() - new Date(patientDateOfBirth).getFullYear() <= 18) {
        return schema
          .required('RP Last Name is required')
          .max(25, 'RP Last Name cannot exceed 25 characters');
      }
      return schema;
    }),
  });
  const {handleSubmit, control, setValue, reset, errors, watch, getValues} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const values = [];
  clientCodeData &&
    Object.entries(clientCodeData)?.forEach(([key, value]) => {
      value?.clientNumber?.length > 0 &&
        value?.clientNumber?.forEach((el, i) => {
          values.push({
            clientName: value?.clientName,
            clientNumber: el,
          });
        });
    });
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);

  useEffect(() => {
    if (errorMsg) {
      setdisabled(false);
    }
  }, [errorMsg]);
  const onSubmit = (data) => {
    const payload = {
      addressLine1: data?.patientAddressLine1 ? data?.patientAddressLine1 : '',
      addressLine2: data?.patientAddressLine2 ? data?.patientAddressLine2 : '',
      admitDate: data?.admitDate ? getFormattedDate(data?.admitDate) : '',
      birthDate: data?.patientDateOfBirth ? getFormattedDate(data?.patientDateOfBirth) : '',
      city: data?.patientCity ? data?.patientCity : '',
      clientNumber:
        data?.clientCode && data?.clientCode?.clientNumber ? data?.clientCode?.clientNumber : '',
      dischargeChangeDate: data?.dischargeDate ? getFormattedDate(data?.dischargeDate) : '',
      dispositionCode: data?.status && data?.status?.valueCode ? data?.status?.valueCode : '',
      emailAddress: data?.patientEmail ? data?.patientEmail : '',
      firstName: data?.patientFirstName ? data?.patientFirstName : '',
      initialBalance: data?.initialBalance ? data?.initialBalance : '',
      lastName: data?.patientLastName ? data?.patientLastName : '',
      mrnNum: data?.mrnNumber ? data?.mrnNumber : '',
      patientPhone: data?.patientPhone ? data?.patientPhone?.replace(/[^\d]/g, '') : '',
      poeInformationRequest: {
        addressLine1: data?.POEAddressLine1 ? data?.POEAddressLine1 : '',
        addressLine2: data?.POEAddressLine2 ? data?.POEAddressLine2 : '',
        city: data?.POECity ? data?.POECity : '',
        poeName: data?.POEName ? data?.POEName : '',
        state: data?.POEState && data?.POEState?.valueCode ? data?.POEState?.valueCode : '',
        zipCode: data?.POEZip ? data?.POEZip : '',
        phone: data?.POEPhone? data?.POEPhone?.replace(/[^\d]/g, '') :'',
      },
      referenceNumber: data?.clientAccountNumber ? data?.clientAccountNumber : '',
      rpInformationRequest: {
        firstName: data?.rpFirstName ? data?.rpFirstName : '',
        lastName: data?.rpLastName ? data?.rpLastName : '',
        phoneNumber: data?.rpPhone ? data?.rpPhone?.replace(/[^\d]/g, '') : '',
        ssn: data?.rpSSN ? data?.rpSSN.replace(/[^\d]/g, '') : '',
      },
      serviceDate: data?.dateOfService ? getFormattedDate(data?.dateOfService) : '',
      ssn: data?.ssnNumber ? data?.ssnNumber.replace(/[^\d]/g, '') : '',
      state:
        data?.patientState && data?.patientState?.valueCode ? data?.patientState?.valueCode : '',
      statusPhase: data?.phase && data?.phase?.valueCode ? data?.phase?.valueCode : '',
      totalCharges: data.totalCharges ? data?.totalCharges : '',
      waitDate: data?.waitDate ? getFormattedDate(data?.waitDate) : '',
      zipCode: data?.patientZip ? data?.patientZip : '',
    };

    if (payload) {
      dispatch(submissionStart());
      setdisabled(true);
      dispatch(
        postPatientContact(payload),
      );
    }
  };

  useEffect(() => {
    if (accountNumber && addPatientStatus === 200) {
      setTimeout(() => {
        history.push({
          pathname: `/account-summary`,
          state: {accountNumber: accountNumber},
        });
      }, 2500);
    }
  }, [accountNumber, addPatientStatus]);
  const handleGetData = (data, typeCode) => {
    let label = [];
    label =
      data && data[typeCode] ?
        [...data[typeCode]].sort((a, b) =>
          a.valueCode > b.valueCode ? 1 : b.valueCode > a.valueCode ? -1 : 0,
        ) :
        [];

    return label;
  };
  return (
    <>
      <div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row global-field-textfields align-items-center new-standard-textfields">
            {/* Client Code */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="clientCode"
                      value={props.value}
                      options={clientCodeDropdownData || []}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.clientName ? option.clientName : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Client Code"
                          name="clientCode"
                          required
                          error={Boolean(errors?.clientCode?.message)}
                          placeholder="Select Client Code"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="clientCode"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.clientCode?.message ? errors.clientCode.message : ''}
              </FormHelperText>
            </div>
            {/* Client Account Number */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  as={
                    <NumberFormat
                      customInput={(params) => (
                        <TextField
                          {...params}
                          className={` ${classes.labelName}`}
                          placeholder="Enter Client Account Number"
                          margin="dense"
                          name="clientAccountNumber"
                          variant="outlined"
                          label="Client Account Number"
                          error={Boolean(errors.clientAccountNumber?.message)}
                          fullWidth
                        />
                      )}
                    />
                  }
                  control={control}
                  name="clientAccountNumber"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.clientAccountNumber?.message ? errors.clientAccountNumber.message : ''}
              </FormHelperText>
            </div>
            {/* Status */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="status"
                      value={props.value}
                      options={handleGetData(dropDownData, DISPOSITION_CODE)}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Status"
                          name="status"
                          required
                          error={Boolean(errors?.status?.message)}
                          placeholder="Select Status"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="status"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined" mt={1}>
                {errors.status?.message ? errors.status.message : ''}
              </FormHelperText>
            </div>
            {/* Phase */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="phase"
                      value={props.value}
                      options={handleGetData(dropDownData, PHASE)}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Phase"
                          name="phase"
                          required
                          error={Boolean(errors?.phase?.message)}
                          placeholder="Select Phase"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="phase"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined" mt={1}>
                {errors.phase?.message ? errors.phase.message : ''}
              </FormHelperText>
            </div>
            {/* Wait Date */}
            <div className={`col-md-4  col-sm-4 col-xl-3 start-enddate  ${
              errors?.waitDate?.message.length > 20 ?
                ' wait-date-error-fields form-group' :
                'form-group'
            }`}>
              <Controller
                render={({value, onChange}) => (

                  <GuiTextDateField
                    className={`${classes.labelName } datefield`}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    helperText={null}
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={value ? value : null}
                    inputVariant="outlined"
                    label="Wait Date"
                    onChange={(date) => {
                      const dateValue = date ? moment(date).format('MM/DD/YYYY') : null;
                      onChange(dateValue);
                      setValue('waitDate', dateValue);
                      // setDateEntered(dateValue);
                      return {value: dateValue};
                    }}
                    autoOk
                    margin="dense"
                    error={Boolean(errors?.waitDate?.message)}
                  />
                )}
                control={control}
                name="waitDate"
              />
              <FormHelperText variant="outlined">
                {errors.waitDate?.message ? errors.waitDate.message : ''}
              </FormHelperText>
            </div>
            {/* Date of Service */}
            <div className={`col-md-4  col-sm-4 col-xl-3 start-enddate  ${
              errors?.dateOfService?.message.length > 20 ?
                ' wait-date-error-fields form-group' :
                'form-group'
            }`}>
              <Controller
                render={({value, onChange}) => (
                  <GuiTextDateField
                    className={`${classes.labelName } datefield`}
                    format="MM/dd/yyyy"
                    // minDate={new Date()}
                    helperText={null}
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={value ? value : null}
                    inputVariant="outlined"
                    label="Service Date"
                    onChange={(date) => {
                      const dateValue = date ? moment(date).format('MM/DD/YYYY') : null;
                      onChange(dateValue);
                      setValue('dateOfService', dateValue);
                      return {value: dateValue};
                    }}
                    autoOk
                    margin="dense"
                    error={Boolean(errors?.dateOfService?.message)}
                  />
                )}
                control={control}
                name="dateOfService"
              />
              <FormHelperText variant="outlined">
                {errors.dateOfService?.message ? errors.dateOfService.message : ''}
              </FormHelperText>
            </div>
            {/* Admit date */}
            <div className={`col-md-4  col-sm-4 col-xl-3 start-enddate ${
              errors?.admitDate?.message.length > 20 ?
                ' wait-date-error-fields form-group' :
                'form-group'
            }`}>
              <Controller
                render={({value, onChange}) => (
                  <GuiTextDateField
                    className={`${classes.labelName } datefield`}
                    format="MM/dd/yyyy"
                    // minDate={new Date()}
                    helperText={null}
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={value ? value : null}
                    inputVariant="outlined"
                    label="Admit Date"
                    onChange={(date) => {
                      const dateValue = date ? moment(date).format('MM/DD/YYYY') : null;
                      onChange(dateValue);
                      setValue('admitDate', dateValue);
                      return {value: dateValue};
                    }}
                    autoOk
                    margin="dense"
                    error={Boolean(errors?.admitDate?.message)}
                  />
                )}
                control={control}
                name="admitDate"
              />
              <FormHelperText variant="outlined">
                {errors.admitDate?.message ? errors.admitDate.message : ''}
              </FormHelperText>
            </div>
            {/* Discharge date */}
            <div className={`col-md-4  col-sm-4 col-xl-3 start-enddate  ${
              errors?.dischargeDate?.message.length > 20 ?
                ' wait-date-error-fields form-group' :
                'form-group'
            }`}>
              <Controller
                render={({value, onChange}) => (
                  <GuiTextDateField
                    className={`${classes.labelName } datefield`}
                    format="MM/dd/yyyy"
                    minDate={new Date(watch('admitDate'))}
                    helperText={null}
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={value ? value : null}
                    inputVariant="outlined"
                    label="Discharge Date"
                    onChange={(date) => {
                      const dateValue = date ? moment(date).format('MM/DD/YYYY') : null;
                      onChange(dateValue);
                      setValue('dischargeDate', dateValue);
                      return {value: dateValue};
                    }}
                    autoOk
                    margin="dense"
                    error={Boolean(errors?.dischargeDate?.message)}
                  />
                )}
                control={control}
                name="dischargeDate"
              />
              <FormHelperText variant="outlined">
                {errors.dischargeDate?.message ? errors.dischargeDate.message : ''}
              </FormHelperText>
            </div>
            {/* Initial Balance */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Initial Balance"
                      margin="dense"
                      name="initialBalance"
                      variant="outlined"
                      label="Initial Balance"
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                      error={Boolean(errors.initialBalance?.message)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        inputComponent: Currency,
                      }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="initialBalance"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.initialBalance?.message ? errors.initialBalance.message : ''}
              </FormHelperText>
            </div>
            {/* Total charges */}
            <div className="col-md-4 col-sm-4 col-xl-3 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Total charges"
                      margin="dense"
                      name="totalCharges"
                      variant="outlined"
                      label="Total charges"
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                      error={Boolean(errors.totalCharges?.message)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        inputComponent: Currency,
                      }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="totalCharges"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.totalCharges?.message ? errors.totalCharges.message : ''}
              </FormHelperText>
            </div>

            <FormFielsSet fieldSetLabel={'Patient/Customer Information'} classes={classes}>
              <PatientCustomerInformation
                classes={classes}
                control={control}
                setValue={setValue}
                errors={errors}
                getValues={getValues}
                watch={watch}
                handleGetData={handleGetData}
                dropDownData={dropDownData}
              />
            </FormFielsSet>

            <FormFielsSet fieldSetLabel={'POE Information'} classes={classes}>
              <POEInformation
                classes={classes}
                control={control}
                setValue={setValue}
                errors={errors}
                getValues={getValues}
                watch={watch}
                handleGetData={handleGetData}
                dropDownData={dropDownData}
              />
            </FormFielsSet>

            <div className="col-md-12">
              <div className=" d-flex justify-content-center">
                <Button
                  type="button"
                  onClick={() => reset(initialValues)}
                  variant="outlined"
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                  disabled={disabled || !roleAccess?.add || enabledSubmission}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </form>
        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </>
  );
}
